var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5284_7138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.61341 8.47513C1.52262 8.33137 1.47723 8.25949 1.45182 8.14862C1.43273 8.06534 1.43273 7.93401 1.45182 7.85073C1.47723 7.73986 1.52262 7.66798 1.61341 7.52422C2.36365 6.33624 4.59682 3.33301 8.00004 3.33301C11.4033 3.33301 13.6364 6.33623 14.3867 7.52422C14.4775 7.66798 14.5228 7.73986 14.5483 7.85073C14.5673 7.93401 14.5673 8.06534 14.5483 8.14862C14.5228 8.25949 14.4775 8.33137 14.3867 8.47513C13.6364 9.66311 11.4033 12.6663 8.00004 12.6663C4.59682 12.6663 2.36365 9.66311 1.61341 8.47513Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 9.99967C9.10457 9.99967 9.99997 9.10424 9.99997 7.99967C9.99997 6.89511 9.10457 5.99967 8.00004 5.99967C6.89551 5.99967 6.00011 6.89511 6.00011 7.99967C6.00011 9.10424 6.89551 9.99967 8.00004 9.99967Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5284_7138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9994,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.0644877a5d4025797453f2e5c8dfc551.svg";
export { ForwardRef as ReactComponent };